import React, { Component } from 'react'

export default class Nav extends Component {
  state={isCollapse:true}

  render() {
    const {isCollapse} = this.state;
    return (
        <nav className="navbar navbar-expand-lg fw-bold h5" style={{direction:'rtl'}}>
        <div className="container-fluid">
          <a className="navbar-brand fw-bolder" href="/home/">Duolingood</a>
          <button className="navbar-toggler" type="button" aria-controls="navbarToggler" aria-expanded={!isCollapse} aria-label="Toggle navigation" onClick={()=>this.setState({isCollapse:!isCollapse})}>
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className={`${isCollapse?'collapse':''} navbar-collapse`} id="navbarToggler">
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <a className="nav-link active" aria-current="page" href="/home/">خانه</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="https://duolingood.ir/how-to-use-duolingood/">آموزش استفاده از سایت</a>
              </li>
              
            </ul>
            <div className="d-flex">
                <button onClick={this.props.onLogout} className="bg-light btn text-white" >خروج از حساب کاربری</button>
            </div>
          </div>
        </div>
      </nav>
    )
  }
}
